export default "__VITE_ASSET__RnwcuWSb__"